module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h2', [_vm._v("Check out how you could #learnwithhato and create something great")]), _vm._v(" "), _c('div', {
    staticClass: "listings"
  }, _vm._l((_vm.instagrams.slice(0, 8)), function(ig) {
    return _c('div', {
      key: ig.url,
      staticClass: "listing"
    }, [_c('a', {
      attrs: {
        "href": ig.url,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "image",
      style: ({
        'backgroundImage': 'url(' + ig.thumbnail + ')'
      })
    })])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6df8d00","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Instagrams.vue
// module id = 224
// module chunks = 1